export default "__VITE_ASSET__BhdyOMFI__"